module.exports = __webpack_public_path__ + "img/stena27.00fabf7f.jpg";